import React from "react";
import { Edit } from "lucide-react";
import { getFinanceCategoryColor } from "./financeConstants";
import { parseAmount } from "./financeUtils";

export default function FinanceDesktopTransactionRow({
  item,
  onEdit,
  readOnlyMode,
  selectedDepartment,
  getDepartmentColor,
}) {
  return (
    <div
      onClick={() => !readOnlyMode && onEdit(item)}
      className={`group flex flex-col gap-2 p-4 bg-white rounded-2xl border border-gray-100 shadow-sm transition relative overflow-hidden ${readOnlyMode ? "cursor-default" : "hover:shadow-md hover:-translate-y-0.5 cursor-pointer"}`}
    >
      <div className={`absolute top-0 left-0 w-1.5 h-full ${item.type === "수입" ? "bg-blue-500" : "bg-rose-500"}`}></div>
      <div className="flex justify-between items-start pl-2">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-1.5 mb-1">
            <span className={`px-2 py-0.5 rounded-md text-[10px] font-bold ${item.type === "수입" ? "bg-blue-50 text-blue-600" : "bg-rose-50 text-rose-600"}`}>
              {item.type}
            </span>
            <span className={`px-2 py-0.5 rounded-md text-[10px] font-bold text-white ${getFinanceCategoryColor(item.category)}`}>
              {item.category}
            </span>
            {selectedDepartment === "All" && item.department && item.department !== "All" && (
              <span className={`px-2 py-0.5 rounded-md text-[10px] font-bold text-white shadow-sm ${getDepartmentColor(item.department)}`}>
                {item.department}
              </span>
            )}
          </div>
          <h4 className="font-bold text-gray-800 truncate">{item.description}</h4>
        </div>
        <div className={`text-sm font-black whitespace-nowrap ${item.type === "수입" ? "text-blue-500" : "text-rose-500"}`}>
          {item.type === "수입" ? "+" : "-"}
          {parseAmount(item.amount).toLocaleString()}
        </div>
      </div>
      <div className="flex justify-between items-end pl-2">
        <span className="text-xs text-gray-400 font-medium">{item.date}</span>
        {!readOnlyMode && (
          <div className="opacity-0 group-hover:opacity-100 transition-opacity">
            <Edit size={14} className="text-gray-400" />
          </div>
        )}
      </div>
    </div>
  );
}
